const values = {
  0: "sm:pl-0",
  0.5: "sm:pl-0.5",
  1: "sm:pl-1",
  1.5: "sm:pl-1.5",
  2: "sm:pl-2",
  2.5: "sm:pl-2.5",
  3: "sm:pl-3",
  3.5: "sm:pl-3.5",
  4: "sm:pl-4",
  5: "sm:pl-5",
  6: "sm:pl-6",
  7: "sm:pl-7",
  8: "sm:pl-8",
  9: "sm:pl-9",
  10: "sm:pl-10",
  12: "sm:pl-12",
  14: "sm:pl-14",
  16: "sm:pl-16",
  20: "sm:pl-20",
  24: "sm:pl-24",
  28: "sm:pl-28",
  32: "sm:pl-32",
  36: "sm:pl-36",
  40: "sm:pl-40",
  44: "sm:pl-44",
  48: "sm:pl-48",
  52: "sm:pl-52",
  56: "sm:pl-56",
  60: "sm:pl-60",
  64: "sm:pl-64",
  72: "sm:pl-72",
  80: "sm:pl-80",
  96: "sm:pl-96",
};

export default function getPaddingLeftSm(value) {
  return values[value];
}
